
(function () {
  let total_stock = 0; // 虚拟库存数量
  let min_interval = 0; // 最小库存
  let final_total_stock = 0; // 最终数量
  let start_time = new Date(); // 开始时间
  let decrease_interval = 0; // 减少间隔
  let decrease_amount_per_interval = []; //减少频率

  // 差值计算
  function calcRemainingInventory(totalInventory, startTime, intervalHours, reduceNumbers, minInterval) {
    
    if (!Array.isArray(reduceNumbers) || reduceNumbers.length === 0) return totalInventory;
    if (intervalHours <= 0) return totalInventory;
    if (reduceNumbers.length === 0 || intervalHours <= 0) return totalInventory;

    const start = startTime instanceof Date ? startTime : new Date(startTime);
    const passedHours = (Date.now() - start.getTime()) / (1000 * 60 * 60);
    const passedPeriods = Math.floor(passedHours / intervalHours);

    if (passedPeriods <= 0) return totalInventory;

    const cycleLength = reduceNumbers.length;
    const fullCycles = Math.floor(passedPeriods / cycleLength);
    const remainingPeriods = passedPeriods % cycleLength;
    const cycleSum = reduceNumbers.reduce((sum, n) => sum + n, 0);
    let result = totalInventory - fullCycles * cycleSum;

    for (let i = 0; i < remainingPeriods; i++) {
      result -= reduceNumbers[i] || 0;
    }

    return result <= min_interval  ? min_interval : result;
  }

  // 基础值获取函数
  function getNormalDatas() {
    // 获取所有.prodcut_variant_select元素
    let selects = document.querySelectorAll(".prodcut_variant_select");
    selects.forEach(function (select) {
      // 获取select的祖先元素（假设为select的父元素的父元素）
      let partenElement = select.parentElement && select.parentElement.parentElement;
      if (!partenElement) return;

      let selectedOption = select.options[select.selectedIndex];
      
      // 获取当前选中的option
      let dataAvailable = selectedOption.getAttribute("data-available");
      
      // 获取按钮元素
      let quickBuy = partenElement.querySelector(".quick_buy");
      let learnMore = partenElement.querySelector(".learn_more");
      let soldOutButton = partenElement.querySelector(".sold_out_button");
      
      // 检查可用性并设置按钮显示状态
      if (!dataAvailable || dataAvailable === "false") {
        if (quickBuy) quickBuy.style.display = 'none';
        if (learnMore) learnMore.style.display = 'none';
        if (soldOutButton) soldOutButton.style.display = 'flex';
      } else {
        if (quickBuy) quickBuy.style.display = 'grid';
        if (learnMore) learnMore.style.display = 'flex';
        if (soldOutButton) soldOutButton.style.display = 'none';
      }
      let marketingCopy = selectedOption.getAttribute("data-marketingCopy") ? selectedOption.getAttribute("data-marketingCopy") : '';
      total_stock = selectedOption.getAttribute("data-totalStock") ? selectedOption.getAttribute("data-totalStock") : '';
      min_interval = selectedOption.getAttribute("data-minInterval") ? selectedOption.getAttribute("data-minInterval") : '';
      start_time = selectedOption.getAttribute("data-startTime") ? selectedOption.getAttribute("data-startTime") : '';
      decrease_interval = selectedOption.getAttribute("data-decreaseInterval") ? selectedOption.getAttribute("data-decreaseInterval") : '';
      // 将decrease_amount_per_interval转换为数组
      try {
        let attr = selectedOption.getAttribute("data-decreaseAmountPerInterval");
        if (attr) {
          if (attr.trim().startsWith('[')) {
            decrease_amount_per_interval = JSON.parse(attr);
          } else {
            decrease_amount_per_interval = attr.split(',').map(Number);
          }
        } else {
          decrease_amount_per_interval = [];
        }
      } catch (e) {
        decrease_amount_per_interval = [];
      }

      if (total_stock === '') {
        partenElement.querySelector(".progress-bar-title").style.display = 'none';
        partenElement.querySelector(".progress-bar-container").style.display = 'none';
        return;
      } else {
        partenElement.querySelector(".progress-bar-title").style.display = 'block';
        partenElement.querySelector(".progress-bar-container").style.display = 'flex';
      }

      final_total_stock = calcRemainingInventory(total_stock, start_time, decrease_interval, decrease_amount_per_interval, min_interval);
      if (final_total_stock == 0) {
        final_total_stock = min_interval;
      }

      if (marketingCopy) {
        let titleEl = partenElement.querySelector(".progress-bar-title");
        if (titleEl) titleEl.innerHTML = marketingCopy;
      }
      if (final_total_stock) {
        let descEl = partenElement.querySelector(".progress-bar-desc");
        if (descEl) descEl.innerHTML = final_total_stock + ' Items Left';
      }

      partenElement.querySelectorAll('.progress-wrapper').forEach(function (progressWrapper) {
        const barFill = progressWrapper.querySelector('.progress-bar-fill');
        const icon = progressWrapper.querySelector('.progress-icon');
        let percent = Math.min(final_total_stock / total_stock, 1);
        if (final_total_stock == 0) {
          percent = 0;
        }
        barFill.style.width = `${percent * 100}%`;

        const wrapperWidth = progressWrapper.offsetWidth; // 适配100%宽度
        const iconBoxWidth = icon.offsetWidth;
        const minLeft = iconBoxWidth / 2;
        const maxLeft = wrapperWidth - iconBoxWidth / 2;
        let left = minLeft + percent * (maxLeft - minLeft) - 0.5;
        icon.style.left = `${left}px`;
      });
    });
  }

  // 页面加载时调用一次getNormalDatas函数
  document.addEventListener("DOMContentLoaded", function () {
    // 页面第一次加载调用一次，之后每小时调用一次
    // 获取类名为decrease_interval_input的input的value值
    var decreaseIntervalInput = document.querySelector('.decrease_interval_input');
    var decreaseIntervalValue = decreaseIntervalInput ? decreaseIntervalInput.value : 1;
    getNormalDatas(); // 首次加载立即调用
    // 清理计时器，避免重复创建
    if (window.__productProgressTimer) {
      clearInterval(window.__productProgressTimer);
    }
    window.__productProgressTimer = setInterval(function() {
      getNormalDatas();
    }, 10000);
  });

// 监听下拉选择变化，更新进度条
document.querySelectorAll('.prodcut_variant_select').forEach(function(select) {
  select.addEventListener('change', function() {
    // 获取父级元素
    const partenElement = select.closest('.longer_right');
    const selectedOption = select.options[select.selectedIndex];

    // 获取相关属性
    let total_stock = selectedOption.getAttribute("data-totalStock") || 0;
    let min_interval = selectedOption.getAttribute("data-minInterval") || 0;
    let start_time = selectedOption.getAttribute("data-startTime") || "";
    let decrease_interval = selectedOption.getAttribute("data-decreaseInterval") || "";
    let marketingCopy = selectedOption.getAttribute("data-marketingCopy") || "";
    let decrease_amount_per_interval = [];

    if (total_stock && start_time && decrease_interval && decrease_amount_per_interval) {
      partenElement.querySelector(".progress-bar-title").style.display = 'block';
      partenElement.querySelector(".progress-bar-container").style.display = 'flex';
      
      try {
        let attr = selectedOption.getAttribute("data-decreaseAmountPerInterval");
        if (attr) {
          if (attr.trim().startsWith('[')) {
            decrease_amount_per_interval = JSON.parse(attr);
          } else {
            decrease_amount_per_interval = attr.split(',').map(Number);
          }
        }
      } catch (e) {
        decrease_amount_per_interval = [];
      }
  
      // 计算剩余库存
      let final_total_stock = 0;
      if (typeof calcRemainingInventory === "function") {
        final_total_stock = calcRemainingInventory(total_stock, start_time, decrease_interval, decrease_amount_per_interval, min_interval);
        if (final_total_stock == 0) {
          final_total_stock = min_interval;
        }
      } else {
        final_total_stock = total_stock;
      }
  
      // 更新文案
      if (marketingCopy && partenElement) {
        let titleEl = partenElement.querySelector(".progress-bar-title");
        if (titleEl) titleEl.innerHTML = marketingCopy;
      }
      if (partenElement) {
        let descEl = partenElement.querySelector(".progress-bar-desc");
        if (descEl) descEl.innerHTML = final_total_stock + ' Items Left';
      }
  
      // 更新进度条
      if (partenElement) {
        partenElement.querySelectorAll('.progress-wrapper').forEach(function (progressWrapper) {
          const barFill = progressWrapper.querySelector('.progress-bar-fill');
          const icon = progressWrapper.querySelector('.progress-icon');
          let percent = Math.min(final_total_stock / total_stock, 1);
          if (final_total_stock == 0) {
            percent = 0;
          }
          if (barFill) barFill.style.width = `${percent * 100}%`;
  
          if (icon && progressWrapper.offsetWidth) {
            const wrapperWidth = progressWrapper.offsetWidth;
            const iconBoxWidth = icon.offsetWidth;
            const minLeft = iconBoxWidth / 2;
            const maxLeft = wrapperWidth - iconBoxWidth / 2;
            let left = minLeft + percent * (maxLeft - minLeft);
            icon.style.left = `${left}px`;
          }
        });
      }
    } else {
      partenElement.querySelector(".progress-bar-title").style.display = 'none';
      partenElement.querySelector(".progress-bar-container").style.display = 'none';
      return;
    }
  });
});

})();
